import Error from "@features/error/error";
import { roundness } from "@provider/dripsy";
import { useDripsyColor } from "@utils";
import { Text, TextInput as TextInputNative, View } from "dripsy";
import * as React from "react";
import type { TextInputProps } from "react-native";

type DripsyProps = React.ComponentProps<typeof TextInputNative>;
type Props = TextInputProps & {
  label?: string;
  color?: string;
  error?: boolean;
  errorMessage?: string | boolean | undefined;

  sx?: DripsyProps["sx"];
};
function TextInput({ label, color = "$background", error, style, errorMessage, ref, ...rest }: Props & { ref?: React.Ref<any> }) {
  const [focused, setFocused] = React.useState(false);
  const placeholderColor = useDripsyColor({ color: "$textGrey" });
  return (
    <>
      <View
        sx={{
          height: 60,
          borderWidth: 2,
          borderColor: error ? "$error" : focused ? "$lightGreen" : "$grey",
          borderRadius: roundness,
          marginTop: 6,
          marginBottom: 6,
        }}
      >
        <View
          sx={{
            position: "absolute",
            top: -11,
            left: 10,
            backgroundColor: color,
            paddingLeft: 6,
            paddingRight: 6,
          }}
        >
          <Text
            sx={{
              fontSize: 14,
              fontWeight: "500",
              color: error ? "$error" : focused ? "$lightGreen" : "$textGrey",
            }}
          >
            {label}
          </Text>
        </View>

        {/*@ts-ignore*/}
        <TextInputNative
          ref={ref as any}
          placeholder={label}
          placeholderTextColor={placeholderColor as any}
          {...rest}
          sx={{
            fontSize: 16,
            fontWeight: "500",
            flex: 1,
            borderRadius: roundness,
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "$2",
            color: error ? "$error" : rest.editable === false ? "$textGrey" : "$text",
            outlineStyle: "none",
          }}
          onFocus={(e) => {
            setFocused(true);
            rest?.onFocus?.(e);
          }}
          onBlur={(e) => {
            setFocused(false);
            rest?.onBlur?.(e);
          }}
          //@ts-ignore
          disabled={rest.editable === false}
        />
      </View>
      {error ? <Error error={errorMessage} isError={!!error} paddingBottom="$2" /> : null}
    </>
  );
}
export default TextInput;
